import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <React.Fragment>
    <path d="M28.2442638,5.51080849 C28.5144369,5.19683489 28.9879812,5.1613275 29.3019548,5.43150052 C29.5873854,5.67711235 29.6426786,6.0907997 29.447388,6.39987874 L29.3812628,6.48919151 L14.179173,24.1558516 C13.9260114,24.4500559 13.4963235,24.4984591 13.1864255,24.285281 L13.0973461,24.2134644 L5.48667257,17.0687372 C5.18468089,16.7852343 5.16969278,16.3105972 5.4531957,16.0086055 C5.71092562,15.7340676 6.12661772,15.6967228 6.42695892,15.9052016 L6.51332743,15.9751286 L13.553,22.583 L28.2442638,5.51080849 Z" />
  </React.Fragment>,
  'CheckMark'
);
